import React from 'react'

import '../styles/needtoknow.css'
import images from '../assets/images'

const NeedToKnow = () => {
  return (
    <>
      <div className="needtoknow">
        <div className="hdr">
          <h1>Everything you need to <span>Trade Smarter</span></h1>
          <p>Our AI analyzes millions oof data points per seccond - so yoou don't have to</p>
        </div>
        <div className="imgs">
          <div className="img lft" style={{backgroundImage: `url(${images.phone4})`}}></div>
          <div className="img ryt" style={{backgroundImage: `url(${images.lptp1})`}}></div>
        </div>
      </div>
    </>
  )
}

export default NeedToKnow